module.exports = __webpack_public_path__ + "img/img11.fa7aa78b.svg";